const API_BASE = 'https://ncht.bz/api/wisdom/monitor';

function buildQuery(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.set(key, String(value));
  });
  return search.toString();
}

function authHeaders(explicitToken) {
  const token = explicitToken || localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
  if (!token) {
    throw new Error('Токен авторизации не найден');
  }
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
}

async function request(path, params = {}, token) {
  const query = buildQuery(params);
  const response = await fetch(`${API_BASE}${path}${query ? `?${query}` : ''}`, {
    headers: authHeaders(token)
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`HTTP ${response.status}: ${text}`);
  }
  return response.json();
}

export function getDashboardSummary(token) {
  return request('/dashboard/summary', {}, token);
}

export function getDashboardTimeseries(params, token) {
  return request('/dashboard/timeseries', params, token);
}

export function getDashboardModes(params, token) {
  return request('/dashboard/modes', params, token);
}

export function getExecutionLogs(params, token) {
  return request('/execution-logs', params, token);
}

export function getExecutionLogModes(token) {
  return request('/execution-logs/modes', {}, token);
}

export function getExecutionLogById(id, token) {
  return request(`/execution-logs/${id}`, {}, token);
}

export function getSessions(params, token) {
  return request('/sessions', params, token);
}

export function getSessionById(id, token) {
  return request(`/sessions/${id}`, {}, token);
}
